<template>
  <v-navigation-drawer
    id="navigation-drawer"
    v-model="drawer"
    touchless
    mobile-breakpoint="960"
    app
    color="drawer_color"
    left
    :mini-variant.sync="mini"
    width="340"
  >
    <v-list expand>
      <v-list-item v-on:click="mini = !mini" class="align-center">
        <v-list-item-icon class="my-auto">
          <v-img max-width="24px" :src="logo" alt="icon logo" v-if="!currentTheme?.partner_logo" contain />
        </v-list-item-icon>
        <v-list-item-content class="text-left">
          <v-img alt="logo text" :src="currentTheme?.partner_logo ?? logoText" max-width="60%" contain />
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="mb-1" />

    <v-list expand>
      <v-list-item
        v-if="partnerSettings.dashboard_access && roles && roles.includes('oms-shop-manager')"
        :to="'/dashboard'"
        :active-class="'secondary'"
      >
        <v-list-item-icon>
          <v-icon>$vuetify.icons.dashboard</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="main-title">{{ $t('drawer.dashboard') | uppercase }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group v-if="isCustomerService && partnerSettings.orders_access">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>$vuetify.icons.box</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('burgerMenu.oms') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item :to="'/dashboard'" dense :active-class="'secondary'">
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('drawer.dashboard') | uppercase }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="'/orders'" dense :active-class="'secondary'">
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('drawer.mainOrder') | uppercase }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="'/sub-orders'" dense :active-class="'secondary'">
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('drawer.subOrders') | uppercase }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <o-list-item
          v-for="(item, index) of pickPackShipCount"
          :key="index"
          :route="item.path"
          :badge-value="item.value || 0"
          :show-badge="!!item.value"
          :label="item.label"
        />
        <o-list-group-wrapper
          :badge-value="orderCounter.blocked || 0"
          :show-badge="!!orderCounter.blocked"
          :label="'drawer.blockedOrders'"
        >
          <o-list-item
            v-for="(item, index) of getBlockedOrdersListItems()"
            :key="index"
            :route="item.path"
            :badge-value="item.value || 0"
            :show-badge="!!item.value"
            :label="item.label"
          />
        </o-list-group-wrapper>

        <v-list-item v-if="partnerSettings.returns_access" :to="'/returns'" :active-class="'secondary'" dense>
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('drawer.returns') | uppercase }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="refundMenuAllowed" :to="'/refunds'" :active-class="'secondary'" dense>
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('drawer.refunds') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="documentsMenuAllowed" :to="'/documents'" :active-class="'secondary'" dense>
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('drawer.documents') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-group
        v-if="
          ((roles && roles.includes('default-user')) || (roles && roles.includes('oms-shop-manager'))) &&
          partnerSettings.orders_access
        "
      >
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>$vuetify.icons.box</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('burgerMenu.orders') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item :dense="true" :to="'/orders/history'">
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <v-badge :inline="true" :left="true" :value="0" class="mt-0">
                <span>
                  {{ $t('drawer.storeOrders') | uppercase }}
                </span>
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="orderSearchActivated" :dense="true" :to="'/orders/search'">
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <v-badge :inline="true" :left="true" :value="0" class="mt-0">
                <span>
                  {{ $t('drawer.searchAnOrder') | uppercase }}
                </span>
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Menu Refunds -->
        <v-list-item v-if="refundMenuAllowed" :dense="true" :to="'/my-refunds'" :active-class="'secondary'">
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <v-badge :inline="true" :left="true" :value="0" class="mt-0">
                <span>
                  {{ $t('drawer.storeRefunds') | uppercase }}
                </span>
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Menu Refunds End -->
      </v-list-group>

      <v-list-group
        v-if="
          ((roles && roles.includes('default-user')) || (roles && roles.includes('oms-shop-manager'))) &&
          partnerSettings.orders_access
        "
      >
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>$vuetify.icons.box</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('burgerMenu.myPreparations') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item v-if="displayWaitingPaymentOrdersMenu" :dense="true" :to="'/orders/waiting-payment'">
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <v-badge
                :inline="true"
                :left="true"
                :value="orderCounter.waiting_payment || 0"
                :content="orderCounter.waiting_payment"
                class="mt-0"
              >
                <span :class="orderCounter.waiting_payment ? 'px-1' : ''">
                  {{ $t('drawer.waitingPayment') | uppercase }}
                </span>
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :dense="true" :to="'/sub-orders/waiting'">
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <v-badge
                :inline="true"
                :left="true"
                :value="subOrderCounter.waiting || 0"
                :content="subOrderCounter.waiting"
                class="mt-0"
              >
                <span :class="subOrderCounter.waiting ? 'px-1' : ''">
                  {{ $t('drawer.awaitingConfirmation') | uppercase }}
                </span>
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :dense="true" :to="'/sub-orders/confirmed'">
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <v-badge
                :inline="true"
                :left="true"
                :value="subOrderCounter.confirmed || 0"
                :content="subOrderCounter.confirmed"
                class="mt-0"
              >
                <span :class="subOrderCounter.confirmed ? 'px-1' : ''">
                  {{ $t('drawer.awaitingPreparation') | uppercase }}
                </span>
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :dense="true" :to="'/sub-orders/waiting-parcel-receipt'">
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <v-badge
                :inline="true"
                :left="true"
                :value="subOrderCounter.waiting_parcel_receipt || 0"
                :content="subOrderCounter.waiting_parcel_receipt"
                class="mt-0"
              >
                <span :class="subOrderCounter.waiting_parcel_receipt ? 'px-1' : ''">
                  {{ $t('drawer.awaitingParcelReceipt') | uppercase }}
                </span>
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :dense="true" :to="'/sub-orders/waiting-carrier'">
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <v-badge
                :inline="true"
                :left="true"
                :value="subOrderCounter.waiting_carrier || 0"
                :content="subOrderCounter.waiting_carrier"
                class="mt-0"
              >
                <span :class="subOrderCounter.waiting_carrier ? 'px-1' : ''">
                  {{ $t('drawer.awaitingCarrierPickup') | uppercase }}
                </span>
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :dense="true" :to="'/orders/waiting-customer'">
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <v-badge
                :inline="true"
                :left="true"
                :value="orderCounter.waiting_customer || 0"
                :content="orderCounter.waiting_customer"
                class="mt-0"
              >
                <span :class="orderCounter.waiting_customer ? 'px-1' : ''">
                  {{ $t('drawer.awaitingCustomerVisit') | uppercase }}
                </span>
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- show-badge is always true here: every sibling of this group wraps its label in a v-badge,
             so the badge layout must be reserved even without a counter to keep the labels aligned -->
        <o-list-item
          v-for="(item, index) of pickPackShipCount"
          :key="index"
          :route="item.path"
          :badge-value="item.value || 0"
          :show-badge="true"
          :label="item.label"
        />
        <v-list-item
          v-if="orderSettings && orderSettings.display && orderSettings.display.display_order_to_put_back_in_stock"
          :dense="true"
          :to="'/sub-orders/to-put-back-in-stock'"
        >
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <v-badge
                :inline="true"
                :left="true"
                :value="subOrderCounter.to_put_back_in_stock || 0"
                :content="subOrderCounter.to_put_back_in_stock"
                class="mt-0"
              >
                <span :class="subOrderCounter.to_put_back_in_stock ? 'px-1' : ''">
                  {{ $t('drawer.toPutBackInStock') | uppercase }}
                </span>
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-container class="py-0" fluid><v-divider></v-divider></v-container>
        <v-list-item :dense="true" :to="'/sub-orders/not-allocated'">
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <v-badge
                :inline="true"
                :left="true"
                :value="subOrderCounter.waiting_allocation || 0"
                :content="subOrderCounter.waiting_allocation"
                class="mt-0"
              >
                <span :class="subOrderCounter.waiting_allocation ? 'px-1' : ''">
                  {{ $t('drawer.marketPlace') | uppercase }}
                </span>
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-container class="py-0" fluid><v-divider></v-divider></v-container>
        <v-list-item :dense="true" :to="'/sub-orders/preparation-history'">
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <v-badge :inline="true" :left="true" :value="0" class="mt-0">
                <span>
                  {{ $t('drawer.preparationHistory') | uppercase }}
                </span>
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <!-- Menu Retour Debut -->
      <v-list-item
        v-if="
          partnerSettings.returns_access &&
          roles &&
          (roles.includes('default-user') || roles.includes('oms-shop-manager'))
        "
        :to="'/returns'"
        :active-class="'secondary'"
      >
        <v-list-item-icon>
          <v-icon>$vuetify.icons.return</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('drawer.returns') | uppercase }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- Menu Retour Fin -->
      <!-- Store documents: outside the "Orders" group, since the list also holds documents attached
           to no order. Hence no orders_access condition either; the central entry stays in the
           OMS group. -->
      <v-list-item
        v-if="documentsMenuAllowed && roles && (roles.includes('default-user') || roles.includes('oms-shop-manager'))"
        :to="'/documents'"
        :active-class="'secondary'"
      >
        <v-list-item-icon>
          <v-icon>mdi-file-document-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('drawer.myDocuments') | uppercase }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- Menu Settings -->
      <v-list-group
        v-if="isOctipasAdmin || (isAdmin && (partnerSettings.settings_access || partnerSettings.returns_access))"
      >
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>$vuetify.icons.configurationManager</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('drawer.configuration') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item
          v-if="partnerSettings.settings_access && partnerSettings.orders_access"
          :to="'/orders-settings'"
          :active-class="'secondary'"
          dense
        >
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('drawer.mainOrder') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item-group v-if="isAdmin && partnerSettings.settings_access">
          <v-list-item :to="'/order-workflows'" dense :active-class="'secondary'">
            <v-list-item-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('drawer.orderWorkflowsManagement') | uppercase }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <v-list-item v-if="partnerSettings.returns_access" :to="'/returns-settings'" :active-class="'secondary'" dense>
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('drawer.returns') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="partnerSettings.settings_access"
          :to="'/customizations/ebookings'"
          :active-class="'secondary'"
          dense
        >
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('drawer.ereservationWidget') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="'/find-in-store-settings'" :active-class="'secondary'" dense>
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('drawer.findInStore') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isAdmin" :to="'/lists'" :active-class="'secondary'" dense>
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('burgerMenu.lists') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isAdmin" :to="'/locations-settings'" :active-class="'secondary'" dense>
          <v-list-item-icon>
            <v-icon></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('burgerMenu.locations') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="'/document-settings'" :active-class="'secondary'" dense>
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('drawer.documents') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <!-- End menu Settings -->

      <v-list-item
        v-if="partnerSettings.carriers_access && isAdmin"
        :to="'/delivery-methods'"
        dense
        :active-class="'secondary'"
      >
        <v-list-item-icon>
          <v-icon>$vuetify.icons.delivery</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('drawer.carriers') | uppercase }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group v-if="displayDigitalInStoreMenu">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>$vuetify.icons.digitalInStore</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('drawer.digitalInStore') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item v-if="canShowDigitalInStoreMenu" @click="openDigitalInStore('')" :active-class="'secondary'" dense>
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('drawer.catalogAndOrder') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="canShowDigitalInStoreMenu"
          @click="openDigitalInStore('#/customers/search')"
          :active-class="'secondary'"
          dense
        >
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('drawer.clients') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="partnerSettings.digital_in_store_access.additional_services_access && isAdmin"
          :to="'/additionalServices'"
          :active-class="'secondary'"
          dense
        >
          <v-list-item-icon>
            <v-icon></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('drawer.additionalServices') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="partnerSettings.lookbook_manager_access && isAdmin"
          :to="'/lookbook-manager'"
          :active-class="'secondary'"
          dense
        >
          <v-list-item-icon>
            <v-icon></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('drawer.lookbook') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- config manager -->
        <o-list-group-wrapper
          v-if="partnerSettings.digital_in_store_access.configuration_manager_access && isAdmin"
          :icon="'$vuetify.icons.configurationManager'"
          :label="'drawer.configurationManager'"
        >
          <o-list-item
            v-for="(item, index) of getConfigManagerListItems()"
            :key="index"
            :route="item.path"
            :label="item.label"
          />
        </o-list-group-wrapper>
      </v-list-group>

      <v-list-group v-if="isOctistockActive || isUnifiedStockActive" :key="gdsKey">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>$vuetify.icons.octistock</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('burgerMenu.octiStock') }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <template v-if="isUnifiedStockActive">
          <v-list-item
            v-if="showUnifiedStockMenu('stocks')"
            :to="'/stocks/list'"
            :active-class="'secondary'"
            :dense="true"
          >
            <v-list-item-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('drawer.consultation') | uppercase }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="showUnifiedStockMenu('parsing_history')"
            :to="'/stocks/parsing-history'"
            :active-class="'secondary'"
            :dense="true"
          >
            <v-list-item-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('drawer.unifiedStockParsingsHistory') | uppercase }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="showUnifiedStockMenu('parsing_export')"
            :to="'/stocks/export-history'"
            :active-class="'secondary'"
            :dense="true"
          >
            <v-list-item-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('drawer.exportHistory') | uppercase }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="showUnifiedStockMenu('transfers')"
            :to="'/stocks/transfers'"
            :active-class="'secondary'"
            :dense="true"
          >
            <v-list-item-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('drawer.stocksTransfers') | uppercase }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="showUnifiedStockMenu('typologies')"
            :to="'/stocks/transfers-typologies'"
            :active-class="'secondary'"
            :dense="true"
          >
            <v-list-item-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('drawer.stocksTransferTypologies') | uppercase }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-if="partnerSettings.reception_access.activeModule">
          <v-list-item
            v-if="partnerSettings.reception_access.activeModule.delivery"
            :to="'/reception'"
            :active-class="'secondary'"
            :dense="true"
          >
            <v-list-item-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('burgerMenu.delivery') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="partnerSettings.reception_access.activeModule.inventory"
            :to="'/inventory/list'"
            :active-class="'secondary'"
            :dense="true"
          >
            <v-list-item-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('burgerMenu.inventory') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="partnerSettings.reception_access.activeModule.retour"
            :to="'/inventory-returns'"
            :active-class="'secondary'"
            :dense="true"
          >
            <v-list-item-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('drawer.returns') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item v-if="isOctistockActive" :to="'/session'" :active-class="'secondary'" :dense="true">
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('burgerMenu.session') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <template v-if="isUnifiedStockActive">
          <v-list-item
            v-if="isAdmin || showUnifiedStockMenu('settings')"
            :to="'/stocks/global-settings'"
            :active-class="'secondary'"
            :dense="true"
          >
            <v-list-item-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('drawer.configuration') | uppercase }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="showUnifiedStockMenu('stocks_settings')"
            :to="'/stocks/settings'"
            :active-class="'secondary'"
            :dense="true"
          >
            <v-list-item-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('drawer.stocksSettings') | uppercase }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list-group>

      <v-list-group
        v-if="isAdmin || partnerSettings.templates_manager_access || partnerSettings.parsings_history_access"
      >
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>$vuetify.icons.setting</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('burgerMenu.integration') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item
          v-if="partnerSettings.templates_manager_access"
          :to="'/templatesmanager/list'"
          :active-class="'secondary'"
        >
          <v-list-item-icon>
            <v-icon>$vuetify.icons.templatesManager</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('drawer.templatesManager') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="isAdmin && partnerSettings.parsings_history_access"
          :to="'/parsings'"
          :active-class="'secondary'"
        >
          <v-list-item-icon>
            <v-icon>$vuetify.icons.parsingsHistory</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('drawer.parsingsHistory') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <o-list-group-wrapper
          v-if="triggersMenuList.length > 0"
          :icon="'$vuetify.icons.triggers'"
          :label="'burgerMenu.triggers'"
        >
          <o-list-item
            v-for="(item, index) of triggersMenuList"
            :key="index"
            :route="item.path"
            :badge-value="item.value"
            :show-badge="false"
            :label="item.label"
          />
        </o-list-group-wrapper>
      </v-list-group>

      <v-list-group v-if="partnerSettings.appointments_access">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('drawer.makingAppointments') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item v-if="isAdmin" :to="'/appointment-services'" :active-class="'secondary'" dense>
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('drawer.serviceManagement') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isCustomerService" :to="'/appointments/all'" :active-class="'secondary'" dense>
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('drawer.allAppointments') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="(roles && roles.includes('default-user')) || (roles && roles.includes('oms-shop-manager'))"
          :to="'/appointments/pending'"
          :active-class="'secondary'"
          dense
        >
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('drawer.pendingAppointments') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="(roles && roles.includes('default-user')) || (roles && roles.includes('oms-shop-manager'))"
          :to="'/appointments/scheduled'"
          :active-class="'secondary'"
          dense
        >
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('drawer.scheduledAppointments') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="(roles && roles.includes('default-user')) || (roles && roles.includes('oms-shop-manager'))"
          :to="'/appointments/past'"
          :active-class="'secondary'"
          dense
        >
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('drawer.pastAppointments') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item disabled v-if="isAdmin" :to="'/appointment-settings'" :active-class="'secondary'" dense>
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('drawer.settings') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-group v-if="partnerSettings.tasks_access">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>$vuetify.icons.tasks</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('drawer.tasksManagement') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item :to="'/tasks'" :active-class="'secondary'" dense>
          <v-list-item-icon>
            <v-icon></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('drawer.tasks') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-group>
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>$vuetify.icons.configurationManager</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">
              {{ $t('drawer.configurations.general') | uppercase }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
        <!-- Menu location -->
        <v-list-item
          v-if="isShopManager && !isCustomerService && partnerSettings.locations_access"
          :to="'/locations/' + currentStore"
          :active-class="'secondary'"
        >
          <v-list-item-icon>
            <v-icon>$vuetify.icons.store</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('burgerMenu.myStore') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-else-if="isCustomerService && partnerSettings.locations_access"
          :to="'/locations'"
          :active-class="'secondary'"
        >
          <v-list-item-icon>
            <v-icon>$vuetify.icons.store</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('burgerMenu.locations') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- End of Menu location -->
        <!-- Menu users -->
        <v-list-item v-if="isAdmin && partnerSettings.users_access" :to="'/users'" :active-class="'secondary'">
          <v-list-item-icon>
            <v-icon>$vuetify.icons.user</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('drawer.users') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-else :to="'/users/' + fusionAuthToken.userId" :active-class="'secondary'">
          <v-list-item-icon>
            <v-icon>$vuetify.icons.user</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('drawer.myAccount') | uppercase }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- End of Menu users -->
        <v-list-item v-if="isOctipasAdmin" :to="'/partners'" :active-class="'secondary'">
          <v-list-item-icon>
            <v-icon>$vuetify.icons.setting</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="main-title">{{ $t('burgerMenu.partners') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item v-if="partnerSettings.analytics_access" @click="redirectToAnalytics()" :active-class="'secondary'">
        <v-list-item-icon>
          <v-icon>mdi-google-analytics</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="main-title">{{ $t('burgerMenu.analytics') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <template v-slot:append>
      <div class="bottom-nav">
        <v-list expand>
          <v-list-item @click="openSelectLocationModal" :disabled="userStores.length <= 1">
            <v-list-item-icon>
              <v-icon>mdi-store-edit-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content v-if="currentStoreDetails">
              <v-list-item-title class="main-title" style="white-space: inherit">
                {{ currentStoreDetails.name }}
              </v-list-item-title>
              <v-list-item-subtitle class="main-subtitle">{{ currentStoreDetails.location_id }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content v-else>
              <v-list-item-title class="main-title" style="white-space: inherit">
                {{ $t('user.noStore') }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="userStores.length > 1">
              <v-icon>mdi-swap-horizontal-bold</v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-list-item v-if="authenticate()" @click="logout">
            <v-list-item-icon style="margin-left: 3px">
              <v-icon>$vuetify.icons.logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content style="margin-left: -3px">
              <v-list-item-title class="main-title">{{ $t('burgerMenu.logout') | uppercase }}</v-list-item-title>
              <v-list-item-subtitle class="main-subtitle" v-if="username">{{ username }}</v-list-item-subtitle>
              <v-list-item-subtitle class="main-subtitle" v-else>{{ userEmail }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
  import { mapState } from 'vuex'
  import { EventBus } from '../event-bus'
  import OListItem from '@/components/navigation/menu/ListItem'
  import OListGroupWrapper from '@/components/navigation/menu/ListGroupWrapper'
  import { DocumentSettingsService } from '@/services/documentSettingsService'
  import { documentMenuAllowed } from '@/helpers/documentDisplay'
  import { ReturnSettingsService } from '@/services/returnSettingsService'
  import { ORDER_COUNT_FILTERS, SUB_ORDER_COUNT_FILTERS } from '@/constants/segments'

  export default {
    name: 'NavigationDrawer',
    components: {
      OListGroupWrapper,
      OListItem,
    },
    data() {
      return {
        logo: require('@/assets/icone-Logo.png'),
        logoText: require('@/assets/LOGO_OCTIPAS_BY_CHAPSVISION.png'),
        subOrderCounter: {},
        orderCounter: {},
        pickPackShipCounter: {},
        // appointmentsEnabled: false,
        partnerSettings: {},
        selectionLocationDialog: false,
        orderSettings: {},
        returnSettings: {},
        documentRequest: 0,
        returnSettingsService: null,
        blockedOrdersListItems: [],
        gdsKey: Date.now(),
      }
    },
    created() {
      this.returnSettingsService = new ReturnSettingsService(this.$auth)
      this.loadDocumentSettings()
      EventBus.$on('documentSettingsSaved', this.documentSettingsSaved)
    },
    async mounted() {
      await this.getPartnerSettings()
      await this.getOrderSettingsByCountry(this.currentStoreDetails?.address?.country_id)
      await this.getReturnSettings(this.currentStoreDetails?.address?.country_id)
      if (!this.isCustomerService) {
        void this.countSubOrderByType()
        void this.countOrderByStatusAndCarrierType()
        EventBus.$on('reLoadCounter', this.countSubOrderByType)
        EventBus.$on('reLoadCounter', this.countOrderByStatusAndCarrierType)
      } else {
        void this.countSubOrderByTypeAdmin()
        void this.countOrderByStatusAndCarrierTypeAdmin()
        EventBus.$on('reLoadCounter', this.countSubOrderByTypeAdmin)
        EventBus.$on('reLoadCounter', this.countOrderByStatusAndCarrierTypeAdmin)
      }

      void this.countPickPackShips()
      EventBus.$on('reLoadCounter', this.countPickPackShips)

      // this.appointmentsEnabled = (process.env.VUE_APP_STORE_APPOINTMENT_API_URL)? true: false
      // this.returnEnabled = (process.env.VUE_APP_RETURN_API_URL)? true: false
    },
    beforeDestroy() {
      this.documentRequest++
      EventBus.$off('documentSettingsSaved', this.documentSettingsSaved)
    },
    watch: {
      $route() {
        if (!this.isCustomerService) {
          this.countOrderByStatusAndCarrierType()
          this.countSubOrderByType()
        } else {
          this.countSubOrderByTypeAdmin()
          this.countOrderByStatusAndCarrierTypeAdmin()
        }
        this.countPickPackShips()
      },
    },
    computed: {
      documentsMenuAllowed() {
        return documentMenuAllowed(this.documentSettings, this.roles, this.isOctipasAdmin)
      },
      drawer: {
        get() {
          return this.$store.state.drawer
        },
        set(val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      mini: {
        get() {
          return this.$store.state.mini
        },
        set(val) {
          this.$store.commit('SET_MINI', val)
        },
      },
      ...mapState([
        'fusionAuthToken',
        'isOctipasAdmin',
        'isAdmin',
        'isCustomerService',
        'isShopManager',
        'currentGroup',
        'currentStore',
        'roles',
        'rolesUnifiedStock',
        'rolesOctiStock',
        'rolesAnalytics',
        'userEmail',
        'username',
        'currentStoreDetails',
        'userStores',
        'currentTheme',
        'documentSettings',
      ]),
      isOctistockActive() {
        return this.partnerSettings.reception_access && this.rolesOctiStock
      },
      orderSearchActivated() {
        if (Array.isArray(this.orderSettings?.display?.display_orders_global_search)) {
          return this.roles.some((role) => this.orderSettings.display.display_orders_global_search.includes(role))
        }
        return false
      },
      refundMenuAllowed() {
        // Super admin (octipas-admin) always sees the menu, regardless of the setting.
        if (this.isOctipasAdmin) {
          return true
        }
        // Secure-by-default: an empty/absent refund_menu_roles hides the menu for everyone
        // until a tenant grants roles (mirrors orderSearchActivated and the API default []).
        const allowedRoles = this.returnSettings?.display?.refund_menu_roles
        if (Array.isArray(allowedRoles)) {
          return this.roles.some((role) => allowedRoles.includes(role))
        }
        return false
      },
      canShowDigitalInStoreMenu() {
        const digitalInStoreAccess = this.partnerSettings.digital_in_store_access
        return digitalInStoreAccess && digitalInStoreAccess.enabled && digitalInStoreAccess.url
      },
      isUnifiedStockActive() {
        return this.partnerSettings.unified_stock_access && this.rolesUnifiedStock && this.rolesUnifiedStock.length
      },
      triggersMenuList() {
        const menu = []
        if (this.isOctipasAdmin) {
          menu.push({
            value: 0,
            path: '/triggers',
            label: this.$t('burgerMenu.triggersList'),
          })
        }
        if (this.isAdmin) {
          menu.push({
            value: 0,
            path: '/triggers-histories',
            label: this.$t('burgerMenu.executionsHistory'),
          })
        }
        if (this.isOctipasAdmin) {
          menu.push({
            value: 0,
            path: '/triggers-settings',
            label: this.$t('drawer.configuration'),
          })
        }
        return menu
      },
      displayDigitalInStoreMenu() {
        const digitalInStoreAccess = this.partnerSettings.digital_in_store_access
        return (
          digitalInStoreAccess &&
          digitalInStoreAccess.enabled &&
          (this.canShowDigitalInStoreMenu ||
            ((digitalInStoreAccess.additional_services_access ||
              digitalInStoreAccess.configuration_manager_access ||
              this.partnerSettings.lookbook_manager_access) &&
              this.isAdmin))
        )
      },
      displayWaitingPaymentOrdersMenu() {
        return this?.orderSettings?.display?.display_waiting_payment_orders_menu?.some((role) =>
          this.roles.includes(role)
        )
      },
      pickPackShipCount() {
        return [
          {
            value: this.pickPackShipCounter?.pick_pack_ship || 0,
            path: '/bins',
            label: this.$t('drawer.binPreparations'),
          },
        ]
      },
    },
    methods: {
      documentSettingsSaved() {
        this.loadDocumentSettings()
      },
      async loadDocumentSettings() {
        // The cache is not emptied first: it would hide the Documents entry for the length of the
        // round trip, and keep it hidden if the call fails — right after a save that succeeded. The
        // request token already stops a stale answer from overwriting a newer one.
        const request = ++this.documentRequest
        if (!this.$store.state.roles) {
          return
        }
        try {
          const settings = await new DocumentSettingsService(this.$auth).getSettings()
          if (request !== this.documentRequest) {
            return
          }
          this.$store.commit('setDocumentSettings', settings)
        } catch {
          /* Menu stays hidden on an unavailable or unauthorized configuration. */
        }
      },
      redirectToAnalytics() {
        let url = process.env.VUE_APP_ANALYTICS_URL
        if (this.rolesAnalytics === 'octipas-admin') {
          url += '?tenant=' + this.currentGroup.name
        }
        window.open(url, '_blank')
      },
      authenticate() {
        return new Date().getTime() < localStorage.getItem('expires_at')
      },
      async logout() {
        this.$auth.logout()
      },
      async countSubOrderByType() {
        // per-segment filters shared with the sub-order routes, so each badge counts exactly what its list shows
        const filters = SUB_ORDER_COUNT_FILTERS

        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          queryStringParameters: {
            filters: JSON.stringify(filters),
            locationId: this.currentStore,
          },
        }
        await this.getSubOrdersCount(myInit)
      },
      async countSubOrderByTypeAdmin() {
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
        }
        await this.getSubOrdersCount(myInit)
      },
      async countOrderByStatusAndCarrierType() {
        // per-segment filters shared with the order routes, so each badge counts exactly what its list shows
        const filters = ORDER_COUNT_FILTERS

        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          queryStringParameters: {
            filters: JSON.stringify(filters),
            locationId: this.currentStore,
            withWaitingPayment: this.displayWaitingPaymentOrdersMenu,
          },
        }

        await this.getCount(myInit)
      },
      async countOrderByStatusAndCarrierTypeAdmin() {
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          queryStringParameters: {
            withWaitingPayment: this.displayWaitingPaymentOrdersMenu,
          },
        }

        await this.getCount(myInit)
      },
      async getCount(myInit) {
        let path = '/v1/int/orders/count'
        try {
          this.orderCounter = await this.$Amplify.API.get('orders', path, myInit)
        } catch (e) {
          console.log(e)
        }
      },
      async getSubOrdersCount(myInit) {
        let path = '/v1/int/sub-orders/count'
        try {
          this.subOrderCounter = await this.$Amplify.API.get('sub-orders', path, myInit)
        } catch (e) {
          console.log(e)
        }
      },
      getBlockedOrdersListItems() {
        return [
          {
            value: this.orderCounter?.non_compliant || 0,
            path: '/orders/non-compliant',
            label: this.$t('drawer.nonCompliant'),
          },
          {
            value: this.subOrderCounter?.waiting_allocation || 0,
            path: '/sub-orders/waiting-allocation',
            label: this.$t('drawer.notAllocatedOrders'),
          },
          {
            value: this.orderCounter?.error || 0,
            path: '/orders/errors',
            label: this.$t('drawer.errorOrders'),
          },
        ]
      },
      getConfigManagerListItems() {
        return [
          {
            path: '/configurations/general',
            label: this.$t('drawer.configurations.general'),
          },
          {
            path: '/configurations/customer',
            label: this.$t('drawer.configurations.customer'),
          },
          {
            path: '/configurations/reachout',
            label: this.$t('drawer.configurations.reachout'),
          },
          {
            path: '/configurations/catalog',
            label: this.$t('drawer.configurations.catalog'),
          },
          {
            path: '/configurations/tunnel',
            label: this.$t('drawer.configurations.tunnel'),
          },
          {
            path: '/configurations/statistics',
            label: this.$t('drawer.configurations.statistics'),
          },
        ]
      },
      async getPartnerSettings() {
        let path = '/v1/partner-settings'
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
        }
        try {
          const res = await this.$Amplify.API.get('partner-settings', path, myInit)
          this.partnerSettings = res
          this.$store.dispatch('setPartnerSettings', this.partnerSettings)
          if (this.partnerSettings.reception_access) {
            this.getOctistockModuleAvailable()
          }
          if (this.partnerSettings.unified_stock_access) {
            this.getUnifiedStockAvailableMenu()
          }
        } catch (e) {
          console.log(e)
        }
      },
      async getOrderSettingsByCountry(countryIso3) {
        // get the settings of the country selected
        this.loadingBtn = true
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
        }
        try {
          const res = await this.$Amplify.API.get('settings', '/v1/settings/' + countryIso3, myInit)
          this.orderSettings = res
        } catch (e) {
          if (e.response?.status === 404 && countryIso3 !== 'FRA') {
            console.log(`No settings for country ${this.currentStoreDetails?.address?.country_id}`)
            await this.getOrderSettingsByCountry('FRA')
          }
        } finally {
          this.loadingBtn = false
        }
      },
      async getReturnSettings(countryIso3) {
        // Returns settings (returns API) carry display.refund_menu_roles, the per-tenant
        // allowlist that gates the central Refunds menu entry. Distinct from orderSettings.
        try {
          this.returnSettings = (await this.returnSettingsService.getReturnSettings(countryIso3)) || {}
        } catch (e) {
          console.error(e)
          this.returnSettings = {}
        }
      },
      openSelectLocationModal() {
        EventBus.$emit('selectLocationDialog')
      },
      openDigitalInStore(path) {
        EventBus.$emit('openDigitalInStore', path)
      },
      getOctistockModuleAvailable() {
        let path = '/bo/config/modules'
        let myInit = {
          headers: {
            Authorization: `Bearer ${this.$auth.accessToken}`,
          },
        }
        this.$Amplify.API.get('inventory', path, myInit)
          .then((res) => {
            this.partnerSettings.reception_access = {
              available: true,
              activeModule: res,
            }
            this.gdsKey = Date.now()
            this.$store.dispatch('setPartnerSettings', this.partnerSettings)
          })
          .catch((e) => {
            console.log(e)
          })
      },
      async countPickPackShips() {
        let path = '/v1/int/pick-pack-ships/count'
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          queryStringParameters: {
            location_id: this.isCustomerService ? undefined : [this.currentStore],
            status: ['picking', 'packing'],
          },
        }
        try {
          this.pickPackShipCounter = await this.$Amplify.API.get('pick-pack-ships', path, myInit)
        } catch (e) {
          console.log(e)
        }
      },
      getUnifiedStockAvailableMenu() {
        let path = '/partner'
        let myInit = {
          headers: {
            Authorization: `Bearer ${this.$auth.accessToken}`,
          },
        }
        this.$Amplify.API.get('stocks', path, myInit)
          .then((res) => {
            if (res.display && res.display.menu && Object.keys(res.display.menu).length > 0) {
              this.partnerSettings.unified_stock_menu = res.display.menu
              this.gdsKey = Date.now()
              this.$store.dispatch('setPartnerSettings', this.partnerSettings)
            }
          })
          .catch((e) => {
            console.log(e)
          })
      },
      showUnifiedStockMenu(menu) {
        return (
          this.isOctipasAdmin ||
          (this.partnerSettings.unified_stock_menu &&
            this.partnerSettings.unified_stock_menu[menu] &&
            this.partnerSettings.unified_stock_menu[menu].values &&
            this.partnerSettings.unified_stock_menu[menu].values.includes(this.rolesUnifiedStock))
        )
      },
    },
  }
</script>
<style scoped>
  .main-title {
    font-size: 0.9rem;
  }

  .main-subtitle {
    font-size: 0.8rem;
  }

  /* New property to stabilize the layout with the scrollbar */
  ::v-deep(.v-list),
  ::v-deep(.v-navigation-drawer__content) {
    scrollbar-gutter: stable;
  }
</style>
<style>
  .v-navigation-drawer .v-list-item:not(.v-list-item--active):not(.v-list-item--disabled),
  .v-navigation-drawer .bottom-nav .v-list-item .v-list-item__subtitle,
  .v-navigation-drawer .bottom-nav .v-list-item:not(.v-list-item--active),
  .v-navigation-drawer .v-list-item:not(.v-list-item--active) .v-icon {
    color: var(--v-drawer_text_color-base, inherit) !important;
  }

  #app.v-application .v-navigation-drawer .v-list > a.v-list-item--active {
    color: var(--v-anchor-base);
  }

  #app.v-application .v-navigation-drawer .v-list-group--active.primary--text .v-badge__badge.primary {
    color: var(--v-primary_text_color-base, var(--v-drawer_text_color-base, inherit)) !important;
  }

  #app.v-application .v-navigation-drawer .v-list-group.primary--text {
    color: var(--v-primary_text_color-base, var(--v-primary-base, inherit)) !important;
  }
</style>
